import { toggleClass } from '../tools/helpers';
import bp from './vars';

// footer cards
document.querySelectorAll('.simple-card').forEach((simpleCard) => {
  simpleCard.addEventListener('click', (evt) => {
    if (window.innerWidth < bp.LG) {
      toggleClass(evt.currentTarget, 'simple-card--active');
    }
  });
});



// WEBPACK FOOTER //
// ./src/javascript/main/footerCards.js